import { render } from "./NavigationButtons.vue?vue&type=template&id=d8442a4e&scoped=true"
import script from "./NavigationButtons.vue?vue&type=script&lang=js"
export * from "./NavigationButtons.vue?vue&type=script&lang=js"

import "./NavigationButtons.vue?vue&type=style&index=0&id=d8442a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8442a4e"]])

export default __exports__